export default __webpack_public_path__ + "static/media/v8-turbofan.024e8e24.svg";